import React, { useEffect, useState } from "react";
import "../styles/Modal.css";

function Modal({ isOpen, onClose, children }) {
  const [show, setShow] = useState(false);
  const [animationClass, setAnimationClass] = useState("");

  useEffect(() => {
    if (isOpen) {
      setShow(true);
      setTimeout(() => setAnimationClass("fadeIn"), 10);
    } else {
      setAnimationClass("fadeOut");
      setTimeout(() => setShow(false), 300);
    }
  }, [isOpen]);

  if (!show) return null;

  return (
    <div className={`modalOverlay ${animationClass}`}>
      <div className="modalContent" onClick={(e) => e.stopPropagation()}>
        <div className="closeButtonDiv">
          <button className="closeButton" onClick={onClose}>
            X
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export default Modal;
